export class EstateProfessionalAccountMeta {
  /**
   * @var {boolean}
   */
  isPrimary;

  constructor(model = {}) {
    this.isPrimary = model.isPrimary;
  }
}
